<template>
  <div class="login" :style="{minHeight: getHeight  + 'px'}">
    <div class="login-view">
      <h4>会员登录</h4>
      <form class="login-form">
        <input v-model="email" type="email" placeholder="请输入邮箱">
        <input v-model="password" type="password" placeholder="请输入密码">
        <input type="button" value="登录" @click="login">
      </form>
      <router-link to="/register">申请注册账号</router-link>
    </div>
  </div>
</template>

<script>
const mailReg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/

export default {
  data () {
    return {
      email: '',
      password: ''
    }
  }, 
  computed: {
    getHeight () {
      return window.innerHeight - 130
    }
  },
  methods: {
    login () {
      if(!this.email || !this.password) {
        alert('请填写完整信息！')
      } else if (!mailReg.test(this.email)) {
        alert('邮箱格式不正确！')
      } else {
        alert('该邮箱暂未注册！')
      }
    }
  }
}
</script>
<style scoped>
.login {
  background-size: cover;
  background-image: url('../assets/banner.png');
  background-position: center;
  position: relative;
}
.login-view {
  width: 350px;
  height: 340px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -175px;
  margin-top: -170px;
  border-radius: 6px;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, .06);
  padding: 40px 0 0;
  text-align: center;
  font-size: 18px;
}
.login-view h4 {
  margin-bottom: 20px;
}
.login-form input {
  display: block;
  width: 300px;
  height: 40px;
  margin: 0 auto;
  background-color: #f2f2f2;
  margin-top: 12px;
  border-radius: 2px;
  text-align: center;
}
.login-form input[type="button"] {
  background-color: #006191;
  color: #fff;
  margin: 68px auto 10px;
  cursor: pointer;
}
.login-form input::placeholder {
  text-align: center;
  font-size: 14px;
}
.login-view a {
  color: #006191;
  font-size: 14px;
}
</style>